import { render } from "./Speaker25.vue?vue&type=template&id=52ce1d39"
import script from "./Speaker25.vue?vue&type=script&lang=js"
export * from "./Speaker25.vue?vue&type=script&lang=js"
script.render = render

export default script